module.exports = {
  INR: 1,
  USD: 0.012, // 1 INR = 0.012 USD
  //   EUR: 0.011, // 1 INR = 0.011 EUR
  //   GBP: 0.0098, // 1 INR = 0.0098 GBP
  //   JPY: 1.72, // 1 INR = 1.72 JPY
};
